import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';
import type {
  FacilityJson,
} from '@/types/domain/childApply/entities/facilityEntity';

export const pageSelector = createSelector(
  (state: RootState) => state.ui.page,
  (page) => page,
);

export const facilityListSelector = createSelector(
  [
    (state: RootState) => state.childApply.facilityList,
    (state: RootState) => state.child.childId,
    (state: RootState) => state.child.childList,
    (state: RootState) => state.childApply.facilityHomepageSettingsList,
  ],
  (facilityList, childId, childList, facilityHomepageSettingsList) => {
    const child = childList.find((v) => v.childId === childId);
    const childFacilityList: FacilityJson[] = [];
    if (child) {
      for (let i = 0; i < facilityList.length; i += 1) {
        if (child.childId === facilityList[i].data.childId
          && child.parentId === facilityList[i].data.parentId) {
          childFacilityList.push(facilityList[i]);
        }
      }
    }
    const facilityHomepageSettings = facilityHomepageSettingsList.find(
      (v) => v.nurseryId === childFacilityList.at(0)?.data.facilityId,
    );
    return {
      /** 子どもの施設リスト */
      childFacilityList,
      /** 施設ホームページ設定  */
      facilityHomepageSettings,
    };
  },
);
